import { Carousel } from "antd";

import { useState } from "react";

import styles from "./carousel.module.scss";

const CustomCarousel = ({ children }: any) => {
  const [currentSlide, setCurrenSlide] = useState(0);

  const handleBeforeChange = (currenSlide: number) => {
    setCurrenSlide(currenSlide);
  };

  return (
    <div className={styles.CarouselContainer}>
      <Carousel autoplay dots={false} beforeChange={handleBeforeChange}>
        {children}
      </Carousel>

      <div className={styles.Dots}>
        <div
          className={`${styles.Dot} ${currentSlide === 0 && styles.Active} `}
        ></div>
        <div
          className={`${styles.Dot} ${currentSlide === 1 && styles.Active}`}
        ></div>
        <div
          className={`${styles.Dot} ${currentSlide === 2 && styles.Active}`}
        ></div>
      </div>
    </div>
  );
};

export default CustomCarousel;
